import React from 'react';
import { injectIntl } from 'react-intl';
import { splitBlocks, NOWRAP_MAX } from './blocks';
import { indexRoles } from './indexRoles';

// Screen-reader label: characters separated by spaces, blocks by commas (the highlight is never the only carrier
// of information: the answer is also written in clear next to the challenge).
const spokenChallenge = (blocks) => blocks.map((block) => block.text.split('').join(' ')).join(', ');

// A `text/plain` challenge: one cell per character, carrying its index in the displayed string (spaces included,
// the convention of the engine solution) and its roles (marker / answer / skipped). A block of up to 16 characters
// never breaks; a longer block (e.g. a single block of 40 or 60) wraps between two characters, never scrolls.
export const TextChallenge = ({ content, highlights, blockSizes, intl }) => {
    const blocks = splitBlocks(content, blockSizes);
    const roles = indexRoles(highlights, content.length);
    return (
        <div
            className="hia-ack-challenge"
            role="group"
            aria-label={intl.formatMessage({ id: 'conventionPage.challenge.ariaLabel' }, { chars: spokenChallenge(blocks) })}
        >
            {blocks.map((block) => (
                <span
                    key={block.start}
                    className={block.text.length > NOWRAP_MAX ? 'hia-ack-block hia-ack-block--long' : 'hia-ack-block'}
                    aria-hidden="true"
                >
                    {block.text.split('').map((char, offset) => {
                        const index = block.start + offset;
                        const cellRoles = roles.get(index);
                        return (
                            <span
                                key={index}
                                className="hia-ack-cell"
                                data-index={index}
                                data-role={cellRoles ? Array.from(cellRoles).join(' ') : undefined}
                            >
                                {char}
                            </span>
                        );
                    })}
                </span>
            ))}
        </div>
    );
};

export default injectIntl(TextChallenge);
